export default __webpack_public_path__ + "static/media/Pendant of Contention.7e0c5481.jpg";